import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Funciona si mi hijo es muy tímido?',
    answer: 'Sí, los guiones están diseñados para ser cortos y fáciles de decir incluso con nervios. No requieren que tu hijo se convierta en alguien extrovertido, solo que aplique respuestas tácticas específicas.'
  }, {
    question: '¿Tengo que pelearme con el colegio?',
    answer: 'No, el método te enseña a documentar profesionalmente para que ellos se vean obligados a actuar por miedo a consecuencias legales, sin necesidad de confrontaciones emocionales en la dirección.'
  }, {
    question: '¿Es seguro aplicar esto?',
    answer: 'Totalmente. Se basa en psicología conductual de no-confrontación. No estamos enseñando a tu hijo a pelear, sino a desactivar la agresión verbal y psicológica de forma segura.'
  }, {
    question: '¿Cuánto tiempo toma ver resultados?',
    answer: 'El cambio en el lenguaje corporal es inmediato; la neutralización del acosador suele tomar entre 5 y 10 días, una vez que se dan cuenta de que ya no obtienen la reacción que buscan.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 md:py-32 bg-offwhite" data-id="element-190">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-191">
        <FadeIn data-id="element-192">
          <div className="text-center mb-16" data-id="element-193">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-teal/10 text-teal mb-6" data-id="element-194">
              <HelpCircle size={32} data-id="element-195" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-196">
              Preguntas Frecuentes
            </h2>
            <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-197"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-198">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-199">
              <div className={`bg-white rounded-2xl border transition-all duration-300 overflow-hidden ${openIndex === index ? 'border-teal shadow-md' : 'border-navy/10 hover:border-navy/20'}`} data-id="element-200">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 md:px-8 md:py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-201">
                  <span className="text-lg md:text-xl font-bold text-navy pr-8" data-id="element-202">
                    {faq.question}
                  </span>
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300 ${openIndex === index ? 'bg-teal text-white rotate-180' : 'bg-offwhite text-navy/50'}`} data-id="element-203">
                    <ChevronDown size={20} data-id="element-204" />
                  </div>
                </button>

                <div className={`px-6 md:px-8 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6 md:pb-8 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-205">
                  <p className="text-navy/70 text-lg leading-relaxed border-t border-navy/5 pt-4" data-id="element-206">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}